import { Component, OnInit } from '@angular/core';
import { Timestamp } from 'firebase/firestore';
import { HOUR24_DATE_CONFIG } from 'src/app/calvin-emr-shared/global';
import { GastrointestinalAssessment } from 'src/app/calvin-emr-shared/models/assessments/gastrointestinal.model';
import { AssessmentInfoComponent } from '../assessment-info/assessment-info.component';
import { AssessmentRowComponent } from '../../assessments-tab/assessment-row/assessment-row.component';

@Component({
  selector: 'app-gastrointestinal-info',
  templateUrl: './gastrointestinal-info.component.html',
  styleUrls: ['./gastrointestinal-info.component.scss'],
  standalone: true,
  imports: [AssessmentRowComponent],
})
export class GastrointestinalInfoComponent
  extends AssessmentInfoComponent<GastrointestinalAssessment>
  implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void { }

  getDateString(tmstp: Timestamp | null) {
    if (!tmstp || tmstp.seconds === 0) {
      return 'N/A';
    }
    return tmstp.toDate().toLocaleString([], HOUR24_DATE_CONFIG).replace(',', ' @');
  }

  get isReducedAppetite() {
    return this.data.reducedAppetite ? 'Yes' : 'No';
  }

  get isTubeFeed() {
    return this.data.tubeFeed ? 'Yes' : 'No';
  }
}
